import Helpers from '../modules/Helpers'

const featuredProperties = document.getElementsByClassName('featured-properties__item')

new Helpers(featuredProperties).eventListener((e) => {
    const code = e.currentTarget.getAttribute('data-cottagecode')
    const position = e.currentTarget.getAttribute('data-position')
    window.dataLayerQueue.push({ 'event': 'featuredPropertyNavigation', 'cottageCode': code, 'position': position });
})
